import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'gatsby';
import Arrow from '../images/svg/arrow-icon.svg';

const CtaIcon = styled.div`
  display: flex;
  width: 36px;
  height: 36px;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1/1;
  border-radius: 9999px;
  border: 1px solid #d4d4d4;
  color: #666666;
  transition: all 0.15s ease-out;
  shape-rendering: crispEdges;
  text-rendering: optimizeLegibility;
  &.dark-theme {
    border: 1px solid #464646;
    color: #fff;
  }
  svg {
    width: 12px;
    height: 12px;
  }
`;

const CtaLabel = styled.p`
  color: #161616;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  transform: translateX(0);
  transition: all 0.15s ease-out;
  text-rendering: geometricPrecision;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -moz-text-size-adjust: 100%;
  text-size-adjust: 100%;
  will-change: transform;
  &.dark-theme {
    color: #fff;
  }
`;

const CtaContainer = styled(Link)<{ $isHovered?: boolean }>`
  display: flex;
  gap: 12px;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
  width: fit-content;
  height: fit-content;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -moz-text-size-adjust: 100%;
  text-size-adjust: 100%;
  text-align: left;
  text-decoration: none;
  transition: all 0.15s ease-out;
  &:active {
    ${CtaIcon} {
      transform: scale(0.97);
    }
  }

  ${({ $isHovered }) =>
    $isHovered &&
    css`
      ${CtaIcon} {
        background-color: #161616;
        border: 1px solid #161616;
        color: #fff;
        transition: all 0.15s ease-out;
        &.dark-theme {
          background-color: #464646;
          border: 1px solid #464646;
          color: #fff;
        }
      }
      ${CtaLabel} {
        transform: translateX(2px);
      }
    `}

  &:hover {
    ${CtaIcon} {
      background-color: #161616;
      border: 1px solid #161616;
      color: #fff;
      transition: all 0.15s ease-out;
      &.dark-theme {
        background-color: #464646;
        border: 1px solid #464646;
        color: #fff;
      }
    }
    ${CtaLabel} {
      transform: translateX(2px);
    }
  }
`;

export default function CtaWithArrow({
  link,
  label,
  isHovered,
  darkTheme
}: {
  link: string;
  label: string;
  isHovered?: boolean;
  darkTheme?: boolean;
}) {
  return (
    <CtaContainer
      to={link}
      $isHovered={isHovered}
      className={darkTheme ? 'dark-theme' : ''}
    >
      <CtaIcon className={darkTheme ? 'dark-theme' : ''}>
        <Arrow />
      </CtaIcon>
      <CtaLabel className={darkTheme ? 'dark-theme' : ''}>{label}</CtaLabel>
    </CtaContainer>
  );
}
